import dayjs, { Dayjs } from 'dayjs'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { EmploymentFormValues } from '../../../../store/types/form/EmploymentFormValues'
import {
  isDateWithinContract,
  isValidDateRange,
  periodOverlapsWithOthers,
} from '../../../../store/utils/employmentUtils'
import DateInput from '../../Inputs/DateInput'

type Props = {
  index: number
  contractStart: Dayjs | null
  contractEnd: Dayjs | null
}

const VacationPeriodEndDateInput = ({ index, contractStart, contractEnd }: Props) => {
  const { t } = useTranslation()
  const { control, getValues, trigger } = useFormContext<EmploymentFormValues>()

  return (
    <DateInput
      control={control}
      name={`vacationPeriods.${index}.endDate`}
      label={t('page.employments.table.to')}
      hideHelperText
      rules={{
        required: true,
        validate: {
          periodRange: v => {
            if (!dayjs.isDayjs(v)) return false
            const start = getValues(`vacationPeriods.${index}.startDate`)
            return isValidDateRange(start, v)
          },
          periodRangeWithinContract: v => {
            if (!dayjs.isDayjs(v)) return false
            return isDateWithinContract(v, contractStart, contractEnd)
              ? true
              : t('page.employments.notifications.periodOutsideContract')
          },
          periodOverlap: v => {
            if (!dayjs.isDayjs(v)) return false
            const start = getValues(`vacationPeriods.${index}.startDate`)
            const allPeriods = getValues('vacationPeriods')
            if (!v || !start) return true
            return !periodOverlapsWithOthers({ startDate: start, endDate: v }, allPeriods, index)
              ? true
              : t('page.employments.notifications.overlappingPeriods')
          },
        },
      }}
      onValueChange={() => {
        trigger(`vacationPeriods.${index}.startDate`)
        trigger(`vacationPeriods.${index}.numberOfDays`)
      }}
    />
  )
}

export default VacationPeriodEndDateInput
